// src/data/dummyProfiles.js
export const dummyProfiles = [
  {
    id: 1,
    name: "Aarohi",
    age: 24,
    distance: "3 km away",
    bio: "Love coffee, sunsets and bad decisions 🌅",
    photos: ["https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=400"],
  },
  {
    id: 2,
    name: "Vihaan",
    age: 27,
    distance: "8 km away",
    bio: "Gym | Travel | Dogs > Cats",
    photos: ["https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400"],
  },
  {
    id: 3,
    name: "Ishita",
    age: 22,
    distance: "1.2 km away",
    bio: "Plant mom 🪴 | Looking for someone to argue about pizza toppings with",
    photos: ["https://images.unsplash.com/photo-1524504388940-b1c1722653e1?w=400"],
  },
  // Add 7–15 more entries for realistic feel
  {
    id: 4,
    name: "Arjun",
    age: 29,
    distance: "5 km away",
    bio: "Probably thinking about food right now",
    photos: ["https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=400"],
  },
  // ... more dummy users
];

export const dummyRequestsToMe = [
  {
    id: 101,
    from: "Riya",
    age: 25,
    message: "Your dog is too cute 😍 Can we go for a walk together?",
    time: "2h ago",
    photo: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=200",
  },
  {
    id: 102,
    from: "Karan",
    age: 28,
    message: "Saw you're into trekking — next weekend?",
    time: "1d ago",
    photo: "https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=200",
  },
];

export const dummyMyRequests = [
  {
    id: 201,
    to: "Neha",
    status: "pending",
    sent: "4h ago",
    photo: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=200",
  },
  {
    id: 202,
    to: "Siddharth",
    status: "pending",
    sent: "Yesterday",
    photo: "https://images.unsplash.com/photo-1552058544-f2b08422138a?w=200",
  },
];

export const dummyDilConnects = [
  {
    id: 301,
    name: "Priya",
    age: 25,
    bio: "Coffee addict | Weekend hiker | Looking for good conversations 🌿",
    photo: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=200",
    matchedAt: "Today, 2:15 PM",
    type: "they-requested", // they sent request, you accepted
  },
  {
    id: 302,
    name: "Rahul",
    age: 28,
    bio: "Engineer by day, foodie by night 🍛 Let's explore Mumbai!",
    photo: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=200",
    matchedAt: "Yesterday",
    type: "i-requested", // you sent, they accepted
  },
  {
    id: 303,
    name: "Ananya",
    age: 23,
    bio: "Books, beats & biryani 📚🎶",
    photo: "https://images.unsplash.com/photo-1524504388940-b1c1722653e1?w=200",
    matchedAt: "3 days ago",
    type: "they-requested",
  },
  {
    id: 304,
    name: "Vikram",
    age: 30,
    bio: "Gym | Travel | Dogs > everything else 🐶",
    photo: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=200",
    matchedAt: "1 week ago",
    type: "i-requested",
  },
  // Add more as needed
];